"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const log_1 = require("../../log");
const log = (0, log_1.getLog)(module);
/**
 * Gets auth headers for a TokenResult, or undefined if no token is available.
 * @param tenant the tenant
 * @param tokenResult the token result
 * @param forceAuthHeader if true header will be always set
 */
function getAuthHeaders(tokenResult) {
    if ((tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.headerName) && (tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.token)) {
        const authHeaders = { [tokenResult.headerName]: `${tokenResult.token}` };
        log.trace('Auth headers: %O', authHeaders);
        return authHeaders;
    }
    return undefined;
}
exports.default = getAuthHeaders;
//# sourceMappingURL=AuthHeaderHelper.js.map